import React, { FC, MouseEvent } from 'react';
import {
  Box,
  Button,
  Body,
  Flex,
  CloseIcon,
} from '@edreamsodigeo/prisma-design-system';
import { Show, useTranslation } from '@edreamsodigeo/frontend-core';

export type FiltersPillProps = {
  id: string;
  label: string;
  pillStatus: PillStatus;
  onClickHandler: () => void;
  onIconClickHandler?: () => void | null;
};

export enum PillStatus {
  default = 'default',
  selected = 'selected',
  disabled = 'disabled',
  appliedFilter = 'appliedFilter',
}

const statusStyles: Record<PillStatus, Partial<unknown>> = {
  default: {
    borderColor: 'neutral.40',
    color: 'neutral.70',
    bg: 'neutral.0',
  },
  selected: {
    borderColor: 'primary',
    color: 'primary.50',
    bg: 'primary.10',
  },
  disabled: {
    pointerEvents: 'none',
    borderColor: 'neutral.40',
    color: 'neutral.70',
    bg: 'neutral.40',
  },
  appliedFilter: {
    paddingRight: '0',
    border: '1.5px solid',
    borderColor: 'primary',
    color: 'primary.50',
    fontWeight: '500',
    bg: 'primary.10',
  },
};

const commonStyles = {
  paddingY: '6px',
  height: '34px',
  border: '1px solid',
};

const tripTypeStyles = {
  paddingRight: 'big',
};

const FiltersPill: FC<FiltersPillProps> = ({
  id,
  label,
  pillStatus = PillStatus.default,
  onClickHandler,
  onIconClickHandler = null,
}) => {
  const { t } = useTranslation();
  const handleOnIconClick = (e: MouseEvent<HTMLElement>): void => {
    e.stopPropagation();
    onIconClickHandler?.();
  };
  const extraStyles = id === 'tripType' ? tripTypeStyles : {};
  return (
    <Button
      sx={{ ...commonStyles, ...statusStyles[pillStatus], ...extraStyles }}
      onClick={onClickHandler}
      data-testid="pill-button"
    >
      <Flex alignItems="center">
        <Body type="small">{label}</Body>
        <Show
          when={pillStatus === PillStatus.appliedFilter && id !== 'tripType'}
        >
          <Box
            pl={'2x_small'}
            pr={'small'}
            sx={{ marginTop: '1px' }}
            onClick={handleOnIconClick}
            data-testid="pill-icon"
          >
            <CloseIcon
              size="tiny"
              aria-label={t('results.results.filters.pill.removeFilter')}
            />
          </Box>
        </Show>
      </Flex>
    </Button>
  );
};

export default FiltersPill;
